import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AirlineSection from "./components/AirlineSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import Header from "./components/Header";
import SecuringSection from "./components/SecuringSection";
import TeasersSection from "./components/TeasersSection";
import { toLanguage } from "./type";

function App() {
  const { i18n } = useTranslation();
  const language = toLanguage(i18n.resolvedLanguage);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <div className="App">
      <Header />
      <SecuringSection />
      <TeasersSection />
      <AirlineSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
